import postAPI from './postAPI.js'

export default async function postCompleteStepPayment(body) {
    const data = await postAPI('taskinstances/steps/payment/complete', body);
    return data;
}
